var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9AA28",
    points: "44,27 4,27 1,23 5,19 43,19 47,23 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFD358",
    d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.748,38.465c-0.387,0-0.754-0.037-1.101-0.112v-1.649c0.115,0.021,0.236,0.046,0.365,0.073 c0.129,0.026,0.269,0.04,0.419,0.04c0.351,0,0.602-0.105,0.752-0.316c0.15-0.212,0.226-0.573,0.226-1.086v-7.267h2.132v7.085 c0,1.062-0.233,1.868-0.698,2.414S15.679,38.465,14.748,38.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.937,30.645c0,0.878-0.259,1.556-0.776,2.033c-0.518,0.479-1.252,0.717-2.205,0.717H21.36V36h-2.122 v-7.853h2.718c0.992,0,1.737,0.217,2.234,0.649C24.688,29.23,24.937,29.847,24.937,30.645z M21.36,31.666h0.387 c0.319,0,0.572-0.09,0.76-0.27c0.188-0.179,0.282-0.426,0.282-0.74c0-0.53-0.293-0.795-0.881-0.795H21.36V31.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.341,31.402h3.389v4.232c-0.92,0.315-1.932,0.473-3.035,0.473c-1.21,0-2.146-0.351-2.806-1.053 c-0.661-0.702-0.991-1.703-0.991-3.002c0-1.268,0.362-2.255,1.085-2.96s1.737-1.058,3.04-1.058c0.494,0,0.96,0.046,1.399,0.139 c0.438,0.094,0.821,0.212,1.146,0.355l-0.671,1.664c-0.566-0.279-1.187-0.418-1.864-0.418c-0.62,0-1.099,0.201-1.437,0.604 c-0.339,0.403-0.508,0.979-0.508,1.727c0,0.734,0.153,1.294,0.459,1.679c0.307,0.385,0.748,0.577,1.324,0.577 c0.315,0,0.605-0.03,0.87-0.091v-1.229h-1.402V31.402z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileJpg);
export default __webpack_public_path__ + "static/media/icon-file-jpg.64b86dc96d64ce689eaecf45d66ded9f.svg";
export { ForwardRef as ReactComponent };